<template>
  <dropdown ref="dropdownRef" title="Last updated">
    <base-ifp-filter
      label="Updated" 
      removable
      @close-clicked="handleCloseClick()"
    >
      <template #value-display>{{ selectedWithinLabel }}</template>
    </base-ifp-filter>
    <template #content>
      <div>
        <ul>
          <li v-for="within in withinOptions" :key="within.value" @click="handleSelectedWithin(within.value)">
            <span :class="{ 'selected' : within.value === lastUpdatedWithinDays }">
              {{ within.label }}
            </span>
          </li>
        </ul>
      </div>
    </template>
  </dropdown>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default defineComponent({
  name: 'IfpFilterLastUpdatedWithinDays',

  props: {
    lastUpdatedWithinDays: {
      type: Number,
      default: null,
    },
  },

  emits: ['last-updated-within-days-updated'],

  data() {
    return {
      withinOptions: [
        {
          label: 'Last day',
          value: 1,
        },
        {
          label: 'Last 2 days',
          value: 2,
        },
        {
          label: 'Last week',
          value: 7,
        },
        {
          label: 'Last 2 weeks',
          value: 14,
        },
        {
          label: 'Last month',
          value: 30,
        },
      ],
    }
  },

  computed: {
    selectedWithinLabel(): string {
      const selected = this.withinOptions.find(
        w => w.value === this.lastUpdatedWithinDays,
      )

      if (selected) {
        return selected.label
      }

      // You can also hand-set the value to anything (180 is max on backend)
      return Math.min(this.lastUpdatedWithinDays, 180) + ' days'
    },
  },

  methods: {
    handleSelectedWithin(value: number) {
      this.$emit('last-updated-within-days-updated', value)
      // @ts-ignore
      this.$refs.dropdownRef.handleClose()
    },
    handleCloseClick() {
      this.handleSelectedWithin(null)
    },
  },
})
</script>
